export default __webpack_public_path__ + "static/media/guild-splash-screen.fb54e8fa.png";